import { NgModule } from '@angular/core';
import { SmartActionsModule } from 'src/app/components/smart-actions/smart-actions.module';
import { AppSearchBarModule } from '../app-search-bar/app-search-bar.module';
import { AppSharedModule } from '../shared.module';
import { AppTopbarComponent } from './app.topbar.component';

@NgModule({
    imports: [
        SmartActionsModule,
        AppSharedModule,
        AppSearchBarModule
    ],
    declarations: [
        AppTopbarComponent
    ],
    exports: [
        AppTopbarComponent
    ]
})
export class AppTopbarModule {
    constructor() {
    }
}
